import axios, { AxiosInstance, AxiosResponse } from 'axios';
import { selectAuthToken } from 'redux/reducers/authReducer';
import { store } from 'redux/store';
import { ResponseError } from 'services/api/base';

export const ampereFileApi = (): AxiosInstance => axios.create({
  baseURL: process.env.REACT_APP_AMPERE_API_URL,
  headers: {
    Authorization: selectAuthToken(store.getState()),
  },
  responseType: 'blob',
});

// O envelope de erro do backend (`{code, message}`) tem poucos bytes. Acima disto a resposta é
// arquivo, e ler como texto um ZIP grande (1,36 GB no SMAP-HISTORICO da Base Mensal) derruba a
// aba do navegador antes do download — não é exceção, o try/catch abaixo não segura.
const MAX_ERROR_ENVELOPE_BYTES = 1024 * 1024;

export const prepareResponse = async (response: AxiosResponse): Promise<Blob | ResponseError> => {
  const blob = new Blob([response.data]);

  if (blob.size > MAX_ERROR_ENVELOPE_BYTES) {
    return blob;
  }

  try {
    const parsedData = JSON.parse(await blob.text());

    if (parsedData.code && parsedData.code !== 200) {
      return { status: parsedData.code, data: parsedData.message };
    }

    return blob;
  } catch (e) {
    return blob;
  }
};
